import styled from "@emotion/styled";
import { Col } from "react-bootstrap";
import { IStyledComponentProps } from "../../theme/theme.types";

const Header = styled.header<IStyledComponentProps>`
  &.ce-soar-header {
    background-color: ${(props) => props.theme?.colors?.brand.primary};
    height: ${(props) => props.theme?.layoutProperties?.headerHeight}px;
    padding: 20px;
    .container-fluid {
      padding-left: 16px;
    }

    &.mobile {
      .container-fluid {
        padding-left: 0;
      }
    }
  }
`;

const LogoColumn = styled(Col)<IStyledComponentProps>`
  &.logo-column {
    display: inline-block;
  }
`;

const TitleColumn = styled(Col)<IStyledComponentProps>`
  &.title-column {
    display: inline-block;
    text-align: center;
    padding: 0 ${(props) => props.theme?.layoutProperties?.logoWidthDesktop}px 0
      0;

    h1 {
      margin: 0;
      padding-right: ${(props) =>
        props.theme?.layoutProperties?.logoWidthDesktop}px;
      color: ${(props) => props.theme?.colors?.essential.white};
      font-size: ${(props) => props.theme.utils?.increaseFontSize(8)};
      font-weight: 900;
    }

    &.mobile {
      padding: 6px
        ${(props) => props.theme?.layoutProperties?.logoWidthMobile}px 0 0;
      h1 {
        font-size: ${(props) => props.theme.utils?.getFontThemeSize("base")};
        padding-right: 0;
      }
    }
  }
`;

export default { Header, TitleColumn, LogoColumn };
